// login
export const USERNAME = 'Username';
export const PASSWORD = 'Password';
export const FORGOT_PASSWORD = 'Forgot Password';
export const FORGOT_PASSWORD_QN = 'Forgot Password?';
export const FOOTER_BRAND = 'Inc. All rights reserved';
export const LOGIN = 'Login';
export const REMEMBER_ME = 'Remember me';
export const INACTIVE_USER_ERROR = 'Your account has been marked as inactive. Reach out to our admin team to reactivate your account.';
export const LOGIN_ERROR = 'Invalid credentials. Please try again.';
export const UNKNOWN_ERROR = 'Something went wrong. Please try again.';
export const SEND_LINK_TO_EMAIL = 'Send link to email';
export const BACK_TO_LOGIN = 'Back to login';
export const ENTER_EMAIL_RESET_LINK = "Enter your email and we'll send you a reset link.";
export const NEW_PASSWORD = 'New password';
export const OLD_PASSWORD = 'Old password';
export const RESET_PASSWORD = 'Reset password';
export const SET_NEW_PASSWORD = 'Set new password';
export const ENTER_NEW_PASSWORD_MESSAGE = 'Enter a new password below to change your password';
export const SET_NEW_PASSWORD_MESSAGE = 'Enter a new password below to set your password';

// header
export const SETTINGS = 'Settings';
export const LOGOUT = 'Logout';
export const SUPER_ADMIN = 'Super admin';
export const ADMIN_STAFF = 'Admin staff';
export const ORG_ADMIN = 'Org admin';
export const ORG_STAFF = 'Org staff';

// Organization
export const MANAGE_ORGANIZATION = 'Manage Organization';
export const ORG_LIST = 'Organization List';
export const INVITE_ORGANIZATION = 'Invite Organization';
export const ORGANIZATION_NAME = 'Organization Name';
export const EMAIL = 'Email';
export const PHONE = 'Phone';
export const WEBSITE = 'Website';
export const REG_DATE = 'Registration Date';
export const CONTACT_NAME = 'Contact Name';
export const PRIMARY_PHONE = 'Primary Phone';
export const SECONDARY_PHONE = 'Secondary Phone';
export const CONTACT_ADDRESS = 'Contact Address';
export const ZIP = 'Zip';
export const CITY = 'City';
export const STATE = 'State';
export const COUNTRY = 'Country';
export const SEND_INVITE = 'Send Invite';
export const FIRST_NAME = 'First Name';
export const LAST_NAME = 'Last Name';
export const CONFIRM_PASSWORD = 'Confirm Password';
export const GET_STARTED = 'Get Started';
export const USERNAME_TAKEN_MSG = 'This username already taken';
export const VENUE_COUNT = 'Venue Count';
export const VENUE_ADDRESS = 'Venue Address';
export const DELETE_ORGANIZATION = 'Delete Organization';
export const DELETE_ORGANIZATION_MSG = 'Do you want to delete this organization?';
export const CONFIRM_DELETE_ORGANIZATION_MSG =
    'You cannot revert this action. This will permanently delete the organization and all the associated venues and users.';

// on-boarding
export const STEP_2 = 'Step 2 of 4';
export const CREATE_FIRST_AVENUE = `Let's create your first Venue`;
export const CREATE_FIRST_AVENUE_MSG = 'Please provide the essential information about the venue and primary contact.';
export const CREATE_SECOND_AVENUE_MSG = 'Upload the logo that will be displayed on web/mobile applications.';
export const CREATE_THIRD_AVENUE_MSG = "Enter the desired URL for your venue. This will be used to create your venue's personalized link.";
export const WHAT_FIRST_AVENUE = 'What is the name of the venue';
export const CHECKING_DOMAIN_AVAILABILITY = 'Checking domain availability...';
export const CREATE_FIRST_AVENUE_WARNING = 'Once you set the URL name, it cannot be changed.';
export const PREFERRED_VENUE_URL = 'Preferred venue URL';
export const STEP_3 = 'Step 3 of 4';
export const STEP_4 = 'Step 4 of 4';
export const UPLOAD_WEB_LOGO = 'Upload Web Logo';
export const UPLOAD_MOBILE_LOGO = 'Upload Mobile Logo';
export const UPLOAD_DIMENSION_MSG = 'Recommended dimensions';
export const VENUE_URL = 'Venue URL';

// Common
export const EDIT = 'Edit';
export const DELETE = 'Delete';
export const STATUS = 'Status';
export const SEARCH = 'Search';
export const ADD = 'Add';
export const UPDATE = 'Update';
export const CANCEL = 'Cancel';
export const CLEAR = 'Clear';
export const SHOWING = 'Showing';
export const TO = 'to';
export const OF = 'of';
export const ITEMS = 'items';
export const LOADING = 'Loading...';
export const NO_ITEMS = 'No Items';
export const COMING_SOON = 'Coming Soon';
export const RESEND_INVITE = 'Resend Invitation';
export const WARNING_MSG = 'Are you sure you want to proceed?';
export const CONTINUE = 'Continue';
export const BACK = 'Back';
export const NAME = 'Name';
export const FINISH = 'Finish';
export const PASSWORD_CHECK_LOWERCASE = 'At least one lowercase';
export const PASSWORD_CHECK_UPPERCASE = 'At least one uppercase';
export const PASSWORD_CHECK_NUMBER = 'At least one number';
export const PASSWORD_CHECK_SPECIAL = 'At least one special character';
export const PASSWORD_CHECK_MIN = 'Minimum 8 characters';
export const SAVE = 'Save';
export const RESET = 'Reset';
export const MY_PROFILE = 'My Profile';
export const PERSONAL_INFORMATION = 'Personal Information';
export const RESET_PASSWORD_PROFILE_TITLE = 'Reset Password';
export const CHANNEL = 'intercom';
export const FORCE_LOGOUT = 'force-logout';
export const MANAGE_PERMISSIONS = 'Manage Permissions';

// Google maps
export const SEARCH_PLACE = 'Search for a place';

// File upload
export const UPLOAD_PHOTO_TYPE_ERROR = 'The selected file is not an image. Please try again.';
export const UPLOAD_VIDEO_TYPE_ERROR = 'The selected file is not a video. Please try again.';
export const USER_UPLOAD_PHOTO_ERROR = 'Error uploading photo.';
export const UPLOAD_PHOTO_INFO = 'Please upload images larger than TXT*TXTpx (Width * Height).';
export const UPLOAD_PHOTO_ERROR = 'The selected image is too small. It must be at least TXT*TXTpx (Width * Height).';
export const DELETE_PHOTO_CONFIRM_MSG = 'Are you sure you want to delete this photo?';

// Permissions
export const DEFAULT_PERMISSIONS = 'Default Permissions';
export const CUSTOM_PERMISSIONS = 'Custom Permissions';
export const ORG_PERMISSIONS = 'Org Permissions';
export const PERMISSION_NAME = 'Permission Name';
export const PERMISSION_DESC = 'Permission Description';
export const ADD_PERMISSION = 'Add Permission';
export const DELETE_PERMISSION_MSG = 'Do you want to delete this permission?';

// Staff Management
export const ADD_STAFF = 'Add Staff';
export const EDIT_STAFF = 'Edit Staff';
export const SEND_PASSWORD_LINK = 'Send Password Link';
export const DISPLAY_NAME = 'Display Name';
export const HIRE_DATE = 'Hire Date';
export const PERMISSION_GROUP = 'Permissions Group';
export const ORGANIZATION = 'Organization';
export const ORGANIZATIONS = 'Organizations';
export const SELECT_ORGANIZATION = 'Select Organization';
export const ADD_ORGANIZATION = 'Add Organization';
export const NO_ORGANIZATIONS_ADDED = 'No organizations added';
export const NO_VENUES_ADDED = 'No venues added';
export const CONFIRM_ADMIN_STAFF_DELETE = 'Do you want to delete this staff?';
export const CONFIRM_ADMIN_STAFF_STATUS_CHANGE = 'Do you want to change the status of this staff?';
export const VENUE = 'Venue';
export const SELECT_VENUE = 'Select Venue';
export const SELECT_PERMISSION_GROUP = 'Select Permission Group';
export const EMPLOYEE_WORK_TIME_SCHEDULE = 'Employee Work Time Schedule';
export const AREA_OF_OPERATION = 'Area of Operation';
export const REMOVE_ORGANIZATION_WARNING = "This will remove the user's access to the organization";
export const REMOVE_VENUE_WARNING = "This will remove the user's access to the venue";

// Venue Management
export const MANAGE_VENUE = 'Manage Venue';
export const VENUE_LIST = 'Venue List';
export const ADD_VENUE = 'Add Venue';
export const ADD_NEW_VENUE = 'Add New Venue';
export const VENUE_NAME = 'Venue Name';
export const TIME_ZONE = 'Time Zone';
export const SELECT_FROM_MAP = 'Select from map';
export const CONFIRM_VENUE_DELETE = 'Do you want to delete this venue?';
export const CONFIRM_Venue_STATUS_CHANGE = 'Do you want to change the status of this venue?';
export const MANAGE_USERS = 'Manage Users';
export const USERS_LIST = 'Users List';
export const ADD_USER = 'Add User';
export const CONFIRM_VENUE_USERS_DELETE = 'Do you want to delete this user?';
export const CONFIRM_VENUE_USERS_STATUS_CHANGE = 'Do you want to change the status of this user?';
export const EDIT_VENUE = 'Edit Venue';
export const POS = 'POS';
export const ROLES = 'Roles';
export const MENU_MANAGEMENT = 'F&B Menu Management';
export const MENU_LIST = 'Menu List';
export const BRANDING = 'Branding';
export const LOGO = 'Logo';
export const THEME_MANAGEMENT = 'Theme Management';
export const DEFAULT = 'Default';
export const CUSTOMIZED = 'Customized';
export const PRIMARY_COLOR = 'Primary Color';
export const SECONDARY_COLOR = 'Secondary Color';
export const TERTIARY_COLOR = 'Tertiary Color';
export const TEXT_COLOR = 'Text Color';
export const PREVIEW = 'Preview';
export const COPY_MENU_ITEMS_TO = 'Copy menu items to';
export const COPY_MENU_ITEMS_FROM = 'Copy menu items from';
export const COPY_USERS_TO = 'Copy users to';
export const COPY_USERS_FROM = 'Copy users from';
export const ORG_SETTINGS_PAGE_INFO =
    'This page allows administrators to configure branding details specific to their organization. These settings will be applied as default branding details for all tenants in the organization';
export const APPLY_TO = 'Apply to';

// Subscription Plans
export const CHOOSE_YOUR_PLAN = 'Choose Your Plan';
export const SUBSCRIPTION_PLANS_DESCRIPTION = 'Streamline your restaurant operations with our comprehensive management platform';
export const MONTHLY = 'Monthly';
export const YEARLY = 'Yearly';
export const FREE = 'Free';
export const PER = 'per';
export const YEAR = 'year';
export const MONTH = 'month';
export const MOST_POPULAR = 'Most Popular';
export const CURRENT_PLAN = 'Current Plan';
export const LOADING_SUBSCRIPTION_PLANS = 'Loading subscription plans...';
export const INVOICE_HISTORY = 'Invoice History';
export const TRIAL_DAYS_LEFT = 'You have {0} days left on your trial. In the trial period, you have access to all the features.';
export const UPGRADE = 'Upgrade';
export const SUBSCRIBE = 'Subscribe';
export const PLAN_STARTED_ON = 'Plan Started on';
export const NEXT_BILLING = 'Next Billing:';
export const DAY_X_OF_Y = 'Day {0} of {1}';
export const CURRENT_PLAN_LABEL = 'Current plan:';
export const PAYMENT_METHOD = 'Payment Method';
export const STRIPE_COMPONENT_PLACEHOLDER = 'Place for Stripe Component.';
export const ACCOUNT_OWNER = 'Account Owner';
export const ACTIVE = 'Active';
export const AUTO_RENEWAL = 'Auto Renewal';
export const AUTO_RENEWAL_DESCRIPTION = 'enable or disable subscription auto-renewal.';
export const LOADING_INVOICES = 'Loading invoices...';
export const NO_INVOICES_FOUND = 'No invoices found for {0}';
export const RENEWS_IN_X_DAYS = 'Renews in {0} days';
export const PER_MONTH = 'Per month';
export const FAILED_TO_FETCH_INVOICES = 'Failed to fetch invoices. Please try again.';
export const FAILED_TO_FETCH_SUBSCRIPTION = 'Failed to fetch subscription details. Please try again.';
export const CONFIRM_YOUR_PLAN = 'Confirm Your Plan';
export const START_YOUR_FREE_TRIAL_OF_PLAN = 'Start your free 14-day trial of {0} — No payment required';
export const CHOOSE_HOW_TO_GET_STARTED = "Choose how you'd like to get started with {0}";
export const TRY_IT_FREE_FOR_14_DAYS = 'Try it free for 14 days';
export const NO_PAYMENT_REQUIRED_NOW = 'No payment required now. Start exploring {0} immediately.';
export const EXPERIENCE_FULL_POWER = 'Experience the full power of {0} with no payment required upfront.';
export const NO_PAYMENT_REQUIRED = 'No payment required';
export const START_IMMEDIATELY_ZERO_COMMITMENT = 'Start immediately with zero commitment';
export const FULL_FEATURE_ACCESS = 'Full feature access';
export const EXPLORE_EVERYTHING = 'Explore everything in {0}';
export const CANCEL_ANYTIME = 'Cancel anytime';
export const NO_CHARGES_IF_CANCEL = 'No charges if you cancel before trial ends';
export const BILLING_SUMMARY = 'Billing Summary';
export const AFTER_TRIAL_PERIOD = 'After trial period';
export const ESTIMATED_TAX = 'Estimated Tax';
export const START_14_DAY_FREE_TRIAL = 'Start 14 Day Free Trial';
export const START_SUBSCRIPTION_NOW = 'Start Subscription Now';
export const ADD_PAYMENT_METHOD_TO_START_SUBSCRIPTION = '*Please add a payment method before starting your subscription.';
export const ADD_PAYMENT_METHOD_LINK = 'Add payment method';
export const ACTIVE_PLAN = 'Active Plan';
export const UPGRADE_PLAN = 'Upgrade Plan';
export const CHARGES_APPLY_DISCLAIMER =
    'Charges apply only when your subscription begins — either after your 14-day trial ends, or immediately if you choose to start your subscription now.';
export const ADVANCED_FEATURES_FOR_GROWING_BUSINESSES = 'Advanced features for growing businesses';
export const START_YOUR_FREE = 'Start your free 14-day trial of {0} — No payment required';
export const SUBSCRIPTION_BEGINS_AUTOMATICALLY = 'Your subscription begins automatically on {0} unless you cancel.';
export const FIRST_CHARGE_ON = 'First charge on {0}';
export const THEN_RENEWS_MONTHLY_ON = 'Then renews monthly on {0}';
export const THEN_RENEWS_YEARLY_ON = 'Then renews yearly on {0}';
export const YOU_WONT_BE_CHARGED =
    "You won't be charged during your 14-day trial. If you choose not to continue, simply cancel before {0} and you won't be billed. By starting your trial, you agree to our Terms of Service.";
export const ORG_NAME = 'Org Name';
export const FREE_PLAN = 'Free Plan';
export const UPCOMING_PLAN = 'Upcoming Plan';
export const UPCOMING_PLAN_STARTS_ON = 'Starts on';
export const CANCEL_SUBSCRIPTION = 'Cancel Subscription';
export const CANCEL_SUBSCRIPTION_DESC = 'Cancel this active subscription.';
export const CANCEL_SUBSCRIPTION_CONFIRM_TITLE = 'Before you cancel:';
export const CANCEL_SUBSCRIPTION_CONFIRM_MSG =
    'Are you sure you want to cancel your subscription? You will continue to have access until the end of your current billing period.';
export const CANCEL_SUBSCRIPTION_BULLET_1 =
    'If you\'d like to switch to a different plan instead, click "View All Plans" and choose the plan you\'d like to change to.';
export const CANCEL_SUBSCRIPTION_BULLET_2 =
    "If you cancel your subscription, you'll still have access to your current plan until the end of your billing period. During this time, you won't be able to switch to another plan.";
export const CANCEL_SUBSCRIPTION_BULLET_3 =
    'Once your current subscription period ends, you can restart your subscription by selecting a new plan.';
export const KEEP_SUBSCRIPTION = 'Keep Subscription';
export const GO_TO_ALL_PLANS = 'View All Plans';
export const FAILED_TO_CANCEL_SUBSCRIPTION = 'Failed to cancel subscription. Please try again.';
export const CARD_ADDED = 'Payment Method Added';
export const CARD_NOT_ADDED = 'Payment Method Not Added';
export const CHANGE_PAYMENT_METHOD = 'Change Payment Method';
export const ADD_NEW_CARD = 'Add New Payment Method';
export const FAILED_TO_LOAD_PAYMENT_PORTAL = 'Failed to open payment portal. Please try again.';
export const NO_ACTIVE_SUBSCRIPTION = 'No Active Subscription';
export const NO_PAYMENT_METHOD_WARNING =
    'A payment method is required to activate or upgrade your subscription. Add one now to get started without interruption.';
export const SUBSCRIPTION_CANCELLED_ALERT =
    'Your subscription has been cancelled. You will continue to have full access until the end of your current billing period. After that, you can subscribe to a new plan anytime.';
// Super Admin Settings
export const SUPER_ADMIN_SETTINGS_INFO_PREFIX = 'This page configures branding for the';
export const SUPER_ADMIN_PORTAL = 'Super Admin portal.';
export const SUPER_ADMIN_SETTINGS_INFO_SUFFIX = 'Updating the logo replaces the logo shown in the header on both web and mobile.';
export const LOGO_SECTION_DESC = 'Shown in the application across web and mobile.';
export const DROP_WEB_LOGO = 'Drop web logo (SVG or PNG)';
export const DROP_MOBILE_LOGO = 'Drop mobile logo (SVG or PNG)';
export const OR_BROWSE_FILES = 'or browse files';
export const WEB_LOGO_RECOMMENDATION = 'Recommended: 240×80px, transparent background.';
export const MOBILE_LOGO_RECOMMENDATION = 'Recommended: 96×96px, transparent background.';
export const REMOVE_LOGO = 'Remove logo';
export const INVALID_LOGO_FILE_TYPE = 'Unsupported file type. Please upload an SVG or PNG image.';
export const DELETE_LOGO_CONFIRM_MSG = 'Are you sure you want to delete this logo?';
export const BRANDING_UPDATED = 'Branding updated successfully.';
export const LOGO_DELETED = 'Logo deleted successfully.';

// Menu Import
export const BULK_UPLOAD = 'Bulk Upload';
export const MENU_IMPORT_DROP_FILES = 'Drag and drop your menu here';
export const MENU_IMPORT_OR_BROWSE = 'or browse files';
export const MENU_IMPORT_FORMAT_HELP = 'One PDF, or up to 10 images. PDF, JPG, JPEG, PNG or WEBP, up to 24 MB each.';
export const MENU_IMPORT_FILE_ERROR_MIXED = 'Choose either one PDF or images, not both.';
export const MENU_IMPORT_FILE_ERROR_PDFS = 'Only one PDF can be uploaded at a time.';
export const MENU_IMPORT_FILE_ERROR_IMAGES = 'You can upload up to 10 images at a time.';
export const MENU_IMPORT_FILE_ERROR_TYPE = 'Unsupported file type. Please upload a PDF, JPG, JPEG, PNG or WEBP file.';
export const MENU_IMPORT_FILE_ERROR_SIZE = 'Each file must be 24 MB or smaller.';
export const MENU_IMPORT_FILE_ERROR_EMPTY = 'One of the files is empty.';
export const MENU_IMPORT_FILE_ERROR_NAME = 'File names must be 255 characters or fewer.';
export const MENU_IMPORT_REMOVE_FILE = 'Remove file';
export const MENU_IMPORT_NO_FILES = 'No files selected yet';
export const MENU_IMPORT_MENU_NAME = 'Menu name';
export const MENU_IMPORT_MENU_NAME_PLACEHOLDER = 'Enter a name for the new menu';
export const MENU_IMPORT_MENU_NAME_REQUIRED = 'Menu name is required.';
export const MENU_IMPORT_MENU_NAME_TOO_LONG = 'Menu name must be 100 characters or fewer.';
export const MENU_IMPORT_NOTHING_ADDED = 'Nothing is added to your menu until you review the extracted items.';
export const MENU_IMPORT_NO_PERMISSION = 'You do not have permission to import menus for this venue.';
export const MENU_IMPORT_NO_VENUE = 'Add a venue to start importing a menu.';
export const MENU_IMPORT_LOAD_ERROR = 'We could not load the menu imports for this venue.';
export const MENU_IMPORT_RETRY = 'Retry';
export const MENU_IMPORT_UPLOADING = 'Uploading your files…';
export const MENU_IMPORT_UPLOADING_DESC = 'Please keep this page open while your files are uploaded.';
export const MENU_IMPORT_EXTRACTING = 'Extracting menu details…';
export const MENU_IMPORT_EXTRACTING_DESC = 'This can take a few minutes. You can leave this page and come back later.';
export const MENU_IMPORT_PAGES_FOUND = 'Pages found:';
export const MENU_IMPORT_FILES_COUNT = 'Files:';
export const MENU_IMPORT_STEP_READING = 'Reading menu file';
export const MENU_IMPORT_STEP_SECTIONS = 'Identifying menu sections';
export const MENU_IMPORT_STEP_ITEMS = 'Extracting menu items';
export const MENU_IMPORT_STEP_PREPARING = 'Preparing menu list';
export const MENU_IMPORT_CANCEL_IMPORT = 'Cancel import';
export const MENU_IMPORT_CANCEL_CONFIRM_TITLE = 'Cancel this import?';
export const MENU_IMPORT_CANCEL_CONFIRM_MSG = 'The extraction will stop and your uploaded files will be discarded.';
export const MENU_IMPORT_KEEP_IMPORTING = 'Keep importing';
export const MENU_IMPORT_FAILED_TITLE = 'We could not extract this menu';
export const MENU_IMPORT_FAILED_DESC = 'Something went wrong while reading your files. You can try again or upload a different file.';
export const MENU_IMPORT_TRY_AGAIN = 'Try again';
export const MENU_IMPORT_UPLOAD_DIFFERENT = 'Upload a different file';
export const MENU_IMPORT_DIALOG_OK = 'OK';
export const MENU_IMPORT_PREVIOUS_TITLE = 'This menu was imported before';
export const MENU_IMPORT_PREVIOUS_MSG = 'These files were already imported for this venue. Do you want to import them again?';
export const MENU_IMPORT_ERROR_TITLE = 'Import problem';
export const MENU_IMPORT_ERROR_IN_PROGRESS = 'Another import is already in progress for this venue. Finish or cancel it first.';
export const MENU_IMPORT_ERROR_CONCURRENT = 'Too many imports are running at the moment. Showing the import that is already running.';
export const MENU_IMPORT_ERROR_MONTHLY = 'Your monthly import limit has been reached. It resets on';
export const MENU_IMPORT_ERROR_LIMIT = 'You have reached your import limit.';
export const MENU_IMPORT_QUOTA_RESETS = 'resets';
export const MENU_IMPORT_QUOTA_LOADING = 'Checking import allowance…';
export const MENU_IMPORT_QUOTA_UNAVAILABLE = 'Import allowance unavailable';
export const MENU_IMPORT_QUOTA_EXHAUSTED = 'The monthly import limit has been reached';
export const MENU_IMPORT_ERROR_UPLOAD = 'We could not upload your files. Please try again.';
export const MENU_IMPORT_ERROR_UNAVAILABLE = 'The import service is not available right now. Please try again shortly.';
export const MENU_IMPORT_ERROR_GENERIC = 'Something went wrong. Please try again.';
export const MENU_IMPORT_REVIEW_READY = 'Ready';
export const MENU_IMPORT_REVIEW_NEEDS_REVIEW = 'Needs Review';
export const MENU_IMPORT_REVIEW_TAB_ALL = 'All';
export const MENU_IMPORT_REVIEW_FILES = 'files';
export const MENU_IMPORT_REVIEW_SOURCE_TITLE = 'Source files';
export const MENU_IMPORT_REVIEW_SEARCH = 'Search items';
export const MENU_IMPORT_REVIEW_COL_NAME = 'Item name';
export const MENU_IMPORT_REVIEW_COL_DESCRIPTION = 'Description';
export const MENU_IMPORT_REVIEW_COL_PRICE = 'Default price';
export const MENU_IMPORT_REVIEW_SELECT_ITEM = 'Select item';
export const MENU_IMPORT_REVIEW_SAVE_ITEM = 'Save item';
export const MENU_IMPORT_REVIEW_CANCEL_EDIT = 'Cancel editing';
export const MENU_IMPORT_REVIEW_SELECT_ALL = 'Select all ready items';
export const MENU_IMPORT_REVIEW_CLEAR = 'Clear';
export const MENU_IMPORT_REVIEW_CLEAR_ARIA = 'Clear selected ready items';
// {count} is replaced with the number of selected rows; the name starts with the visible label "Remove (N)".
export const MENU_IMPORT_REVIEW_REMOVE_ARIA = 'Remove ({count}) selected items';
export const MENU_IMPORT_REVIEW_REMOVE_TITLE = 'Remove items?';
export const MENU_IMPORT_REVIEW_REMOVE_ONE = 'This item will be removed from the import.';
export const MENU_IMPORT_REVIEW_REMOVE_MANY = 'The selected items will be removed from the import.';
export const MENU_IMPORT_REVIEW_DISCARD = 'Discard and start new';
export const MENU_IMPORT_REVIEW_DISCARD_TITLE = 'Discard this import?';
export const MENU_IMPORT_REVIEW_DISCARD_MSG = 'The extracted menu and your changes will be discarded, and you can upload new files.';
export const MENU_IMPORT_REVIEW_EMPTY = 'No menu items found';
export const MENU_IMPORT_REVIEW_NO_MATCH = 'No items match';
export const MENU_IMPORT_REVIEW_CONFLICT_TITLE = 'Menu changed elsewhere';
export const MENU_IMPORT_REVIEW_CONFLICT_MSG = 'This import was changed in another session. It has been reloaded with the latest version.';
export const MENU_IMPORT_REVIEW_ERROR_NAME = 'Item name must be 2 to 100 characters.';
export const MENU_IMPORT_REVIEW_ERROR_DESCRIPTION = 'Description must be 500 characters or fewer.';
export const MENU_IMPORT_REVIEW_ERROR_PRICE = 'Price must be a number with at most 2 decimals.';
export const MENU_IMPORT_REVIEW_SAVE_REFUSED = 'Your change could not be saved. The import has been reloaded.';
export const MENU_IMPORT_ADDING_TITLE = 'Adding items to your menu…';
export const MENU_IMPORT_ADDING_DESC = 'This can take a few minutes. Please keep this page open.';
export const MENU_IMPORT_ADDED = 'Added';
export const MENU_IMPORT_VIEW_MENU = 'View Menu';
export const MENU_IMPORT_CONTINUE_REVIEWING = 'Continue reviewing';
export const MENU_IMPORT_CLOSE = 'Close';
export const MENU_IMPORT_SUCCESS_TITLE = 'Menu items added';
export const MENU_IMPORT_SUCCESS_COMPLETE = 'Menu items were added to';
export const MENU_IMPORT_SUCCESS_PARTIAL = 'Some menu items were added to';
export const MENU_IMPORT_SUCCESS_PARTIAL_NOTE = 'The remaining items are still waiting in this import.';
export const MENU_IMPORT_SUCCESS_COUNT = 'Items added:';
export const MENU_IMPORT_COMMIT_FAILED_TITLE = 'Some items were not added';
export const MENU_IMPORT_COMMIT_FAILED_MSG = 'Adding your items to the menu was interrupted. You can retry to add the rest.';
export const MENU_IMPORT_NOTHING_TO_ADD_TITLE = 'Nothing was added';
export const MENU_IMPORT_NOTHING_TO_ADD_MSG = 'None of the selected items could be added to your menu. Review them and try again.';
export const MENU_IMPORT_ADD_REFUSED_MSG = 'There is nothing left to add from this import.';
export const MENU_IMPORT_ADD_UNAVAILABLE_MSG = 'Adding menus is not available right now. Please try again shortly.';
export const MENU_IMPORT_FINISH = 'Finish import';
export const MENU_IMPORT_FINISH_TITLE = 'Finish this import?';
export const MENU_IMPORT_FINISH_MSG =
    'The items already added stay in your menu. The items that were not added will not be added from this import.';
export const MENU_IMPORT_DISCARD_ADDED_MSG =
    'The items already added stay in your menu. The items that were not added will not be added from this import, and you can upload new files.';

// Bulk Upload redesign (steps strip, toolbar review, row actions)
export const MENU_IMPORT_SUBTITLE = 'Import a menu from a PDF or photos, review it, then add it to the venue.';
export const MENU_IMPORT_STEPS_ARIA = 'Import steps';
export const MENU_IMPORT_STEP_UPLOAD = 'Upload';
export const MENU_IMPORT_STEP_EXTRACT = 'Extract';
export const MENU_IMPORT_STEP_REVIEW = 'Review';
export const MENU_IMPORT_STEP_ADD = 'Add to menu';
export const MENU_IMPORT_QUOTA_THIS_MONTH = 'Imports this month';
export const MENU_IMPORT_QUOTA_OF = 'of';
export const MENU_IMPORT_FILES_HEADING = 'Files {count} of {max}';
export const MENU_IMPORT_CLEAR_ALL = 'Clear all';
export const MENU_IMPORT_EXTRACT_MENU = 'Extract menu';
export const MENU_IMPORT_UPLOAD_HINT_MISSING = 'Add files and a menu name to continue';
export const MENU_IMPORT_MENU_LABEL = 'Menu:';
export const MENU_IMPORT_REVIEW_MARK_READY = 'Mark ready';
export const MENU_IMPORT_REVIEW_NO_DESCRIPTION = 'No description';
export const MENU_IMPORT_REVIEW_BACK_TO_REVIEW_ARIA = 'Move {name} back to needs review';
export const MENU_IMPORT_REVIEW_MARK_READY_ARIA = 'Mark {name} ready';
export const MENU_IMPORT_REVIEW_EDIT_ARIA = 'Edit {name}';
export const MENU_IMPORT_REVIEW_DELETE_ARIA = 'Delete {name}';
export const MENU_IMPORT_REVIEW_SELECTED_COUNT = '{count} selected';
export const MENU_IMPORT_REVIEW_SELECT_ALL_READY = 'Select all {count} ready';
export const MENU_IMPORT_REVIEW_REMOVE_COUNT = 'Remove {count}';
export const MENU_IMPORT_REVIEW_BULK_ACTIONS_ARIA = 'Bulk actions';
export const MENU_IMPORT_REVIEW_FILTER_ARIA = 'Filter items';
export const MENU_IMPORT_REVIEW_ITEM_DELETED = '{name} deleted';
export const MENU_IMPORT_REVIEW_ITEMS_DELETED = '{count} items deleted';
export const MENU_IMPORT_REVIEW_UNDO = 'Undo';
export const MENU_IMPORT_REVIEW_SHOWING = 'Showing {from}–{to} of {total}';
export const MENU_IMPORT_REVIEW_SHOWING_NONE = 'No items';
export const MENU_IMPORT_REVIEW_FOOTER_HINT = 'Only Ready items can be added';
export const MENU_IMPORT_REVIEW_FOOTER_HINT_PENDING = '{count} still need review';
export const MENU_IMPORT_ADD_N_ITEM = 'Add {count} item to menu';
export const MENU_IMPORT_ADD_N_ITEMS = 'Add {count} items to menu';
export const MENU_IMPORT_ADD_TO_MENU_LOWER = 'Add to menu';
